export default "__VITE_ASSET__DjbkLc7g__"